<template>
	<div class='tax-accordance'>
		<div :class='{ "not-match": !isMatchTaxAccords }'>
			<custom-p-checkbox
				v-model='valueTaxAccords'
				label='Фактическая таксационная характеристика лесного насаждения соответствует ТО'
			/>
		</div>

		<div v-if="!valueTaxAccords" class='grid select-value-block'>

			<div :class='{ "not-match": !isMatch(values["fullness_new"]) }'>
				<span class='select-title'>Полнота</span>
				<custom-p-select
					v-model='values["fullness_new"].value'
					:options='info_fullness'
					:disabled='valueTaxAccords || !actLpoIsDraft'
					:optionLabel='null'
					:dataKey='null'
				/>
			</div>

			<!--<div v-if='lpo.inspection_type_id !== "2"' :class='{ "not-match": !isMatch(values["d_avg"]) }'>-->
			<div :class='{ "not-match": !isMatch(values["d_avg"]) }'>
				<span class='select-title'>Средний диаметр, см</span>
				<input
					v-if='valueTaxAccords'
					disabled
					class='custom-input'
				>
				<input
					v-else
					v-model='values["d_avg"].value'
					class='custom-input'
					:disabled='!actLpoIsDraft'
				>
			</div>

			<div :class='{ "not-match": !isMatch(values["is_mixed"]) }'>
				<span class='select-title'>Состав насаждений</span>
				<template v-if='valueTaxAccords'>
					<label>
						<input type='radio' disabled>
						<span>Чистые</span>
					</label>
					<label>
						<input type='radio' disabled>
						<span>Смешанные</span>
					</label>
				</template>
				<template v-else>
					<label>
						<input type='radio' :value='false' v-model='values["is_mixed"].value' :disabled='!actLpoIsDraft'>
						<span>Чистые</span>
					</label>
					<label>
						<input type='radio' :value='true' v-model='values["is_mixed"].value' :disabled='!actLpoIsDraft'>
						<span>Смешанные</span>
					</label>
				</template>
			</div>
		</div>
		<PMessage v-if="!lpoTaxAccordance && (lpo.fullness_new == null || lpo.d_avg == null || lpo.is_mixed == null)" severity="error" :closable="false">При несоответствии обязательны для заполнения поля: полнота, средний диаметр, состав насаждения</PMessage>
		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length || !isMatchTaxAccords'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	const info_fullness = [ '0.2', '0.3', '0.4', '0.5', '0.6', '0.7', '0.8', '0.9', '1' ];

	export default {
		name: 'InspectionTaxAccordance',
		data() {
			return {
				valueTaxAccords: false,

				values: {
					fullness_new: {
						field: 'fullness_new',
						inputType: 'input',
						value: null,
					},

					d_avg: {
						field: 'd_avg',
						inputType: 'input',
						value: null,
					},

					is_mixed: {
						field: 'is_mixed',
						inputType: 'checkbox',
						value: false,
					}
				},

				info_fullness

			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			lpoTaxAccordance() {
				return this.lpo.visual_tax_accordance === 't' ? true : false;
			},

			isMatchTaxAccords() {
				return this.valueTaxAccords === this.lpoTaxAccordance;
			},

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			...mapState({
				lpo: state => state.selectedLpo.lpo
			})
		},
		watch: {
			valueTaxAccords(value) {
				this.values.fullness_new.value = null;
			}
		},
		methods: {
			save() {
				const valueList = [];

				if (this.valueTaxAccords) {

					const temp = {
						field: 'visual_tax_accordance',
						value: true
					};
					valueList.push(temp);

					for (const value_name in this.values) {
						const value = this.values[value_name];

						const temp = {
							field: value.field,
							value: null
						};
						valueList.push(temp);
					}

				} else {

					const temp = {
						field: 'visual_tax_accordance',
						value: false
					};
					valueList.push(temp);

					for (const value_name of this.notMatchingValues) {
						const inputTypeIsSelect = this.values[value_name].inputType === 'select';

						const temp = {
							field: this.values[value_name].field,
							value: inputTypeIsSelect  ? this.values[value_name].value.id : this.values[value_name].value === '' ? null: this.values[value_name].value
						};
						valueList.push(temp);
					}
				}

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo().then(res => {
						this.getCircleR();
						this.getCircleCount();
					});
				});
			},

			cancel() {
				this.resetValues();
			},

			resetValues() {
				this.valueTaxAccords = this.lpoTaxAccordance;

				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}
			},

			isMatch(value) {

				if (this.valueTaxAccords) {
					return true;
				}

				if (value.inputType === 'input') {
					return (value.value == '' ? null: value.value)  === this.lpo[value.field];
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				} else if (value.inputType === 'checkbox') {
					let a;
					if (this.lpo[value.field] === 't') {
						a = true;
					} else if (this.lpo[value.field] === 'f') {
						a = false
					} else {
						a = null;
					}
					return value.value === a;
				}

				return false;
			},

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			]),
			...mapActions('selectedLpo/recount', [
				'getCircleR',
				'getCircleCount',
			])
		},
		created() {
			this.resetValues();
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}

</style>